import Storage from 'answer/helpers/storage'
import i18next from "i18next"
import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import Select from "react-select-v5"
import "register/less/registration.less"
import "register/less/welcome-page.less"
import Button from 'shared/components/button'
import { guessTimeZone } from 'shared/helpers/localization'
import { customStyles, mapOptionsToGroups } from "../../shared/helpers/attribute"
import { getAttributesList, getCountriesAndMarketsByBrand, getRecruitmentChannels, postAttributesList, secondRegister, showSecondBrand, checkUniqueAttribute } from "../apicalls/api-calls"
import { ADDRESS_1, ADDRESS_2, CITY, COUNTRY_OF_RESIDENCE, FIRST_NAME, isInteger, isPickMany, isPickOne, isText, LANGUAGE, LAST_NAME, mapBySection, PICK_ONE_LIST, STATE_OF_RESIDENCE, TEXT_INPUT, ZIP_CODE, UNIQUE_SECTION, buildUniqueAttributes } from "../helper/attribute"
import { generateNewCaptchaToken } from '../helper/captcha'
import { INCROWD_BRAND, INCROWD_RESPONDER_TYPE_ID, OS_HCP_BRAND, OS_RESPONDER_TYPE_ID, setTimeZoneDefaultValue } from '../helper/registration'
import JoinIncrowdComponent from "./JoinIncrowdComponent"
import JoinOpinionSiteComponent from "./JoinOpinionSiteComponent"
import RecruitmentComponent from "./RecruitmentComponent"
import SectionComponent from "./SectionComponent"
import TermsAndConditionsComponent from "./TermsAndConditionsComponent"


const WelcomeComponent = (props) => {
    const { t } = useTranslation()
    const [marketId, setMarketId] = useState("")
    const [languageId, setLanguageId] = useState("")
    const [languages, setLanguages] = useState([])
    const [isLanguageDisabled, setIsLanguageDisabled] = useState(true)
    const [countries, setCountries] = useState([])
    const [countryId, setCountryId] = useState("")
    const [countryIsoCode, setCountryIsoCode] = useState("")
    const [markets, setMarkets] = useState([])
    const [email, setEmail] = useState(props.email)
    const [isCountryDisabled, setIsCountryDisabled] = useState(false)
    const [isMarketDisabled, setIsMarketDisabled] = useState(true)
    const [showAttributeList, setShowAttributeList] = useState(false)
    const [showUniqueSection, setShowUniqueSection] = useState(false)
    const [uniqueAttributes, setUniqueAttributes] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isButtonLoading, setIsButtonLoading] = useState(false)
    const [spinnerSrc, setSpinnerSrc] = useState("")
    const [attributes, setAttributes] = useState({})
    const [filterAttributes, setFilterAttributes] = useState([])
    const [password, setPassword] = useState({})
    const [mobileNumber, setMobileNumber] = useState({})
    const [sendEmailAndSms, setSendEmailAndSms] = useState({})
    const [termsAndConditions, setTermsAndConditions] = useState({})
    const [nonAttributeFields, setNonAttributesFields] = useState([])
    const [stateOfResidenceChoices, setStateOfResidenceChoices] = useState([])
    const [errorMessage, setErrorMessage] = useState("")
    const [highlightErrors, setHighlightErrors] = useState(false)
    const [showJoinIncrowd, setShowJoinIncrowd] = useState(false)
    const [showJoinOS, setShowJoinOS] = useState(false)
    const [otherBrandAttributes, setOtherBrandAttributes] = useState([])
    const [joinedOtherBrandId, setJoinedOtherBrandId] = useState(0)
    const [joinIncrowdSelected, setJoinIncrowdSelected] = useState(false)
    const [joinOSSelected, setJoinOSSelected] = useState(false)
    const [loadingOtherBrandAttributes, setLoadingOtherBrandAttributes] = useState(false)
    const [displayRecruitment, setDisplayRecruitment] = useState(false)
    const [recruitmentChannelsList, setRecruitmentChannelsList] = useState({})

    const defaultCountryId = 641

    const sectionNames = {
        3: 'form.section_2',
        4: 'form.section_3',
        5: 'form.section_4',
        6: 'form.section_5',
    }

    useEffect(() => {
        //Set initial language attribute value
        setLanguageId(props.languageId)
        setShowJoinIncrowd(props.showJoinIncrowd)
        setShowJoinOS(props.showJoinOS)
    }, [])

    useEffect(() => {
        if (props.isShgRegistration) {
            setSpinnerSrc("/images/spinner_os.gif")
        } else {
            setSpinnerSrc("/images/spinner.gif")
        }
    }, [props.isShgRegistration])

    useEffect(() => {
        if (props.marketId) {
            //Get filter attributes
            setIsLoading(true)
            const parameters = {
                countryId: defaultCountryId,
                marketId: props.marketId,
                languageId: props.languageId,
                brandId: props.brandId,
                userId: props.userId,
                accessToken: props.accessToken,
            }
            getAttributesList(parameters, setErrorMessage,
                (attributesList) => onFirstGetAttributesListDone(attributesList))
        }
    }, [props.marketId])


    useEffect(() => {
        if (languageId) {
            props.updateLanguage(languageId)
            //On language change, get the translated recruitment channels
            if (displayRecruitment) {
                const langIsoCode = i18next.language
                getRecruitmentChannels(langIsoCode, mapRecruitmentListToSection)
            }
        }

    }, [languageId])

    useEffect(() => {
        if (props.recruitmentSource == null || props.recruitmentSource == "") {
            setDisplayRecruitment(true)
        }
    }, [props.recruitmentSource])

    const checkUniqueAttributesValidity =()=>{
        if(uniqueAttributes.every(uniqueAttr=>uniqueAttr.valid)){
            setShowAttributeList(true)
        }
    }
    const setCountriesAndMarketsByBrand = (countriesResult, attributesFirstSection) => {
        setCountries(countriesResult)
        evaluateCountryLabels(attributesFirstSection)
        if (countriesResult.length == 1) {
            setIsCountryDisabled(true)
            onChangeCountry(countriesResult[0].value, countriesResult, props.languageId)
        }
    }

    const mapRecruitmentDetailsToAttribute = (list) => {
        return list.map((choice) => ({
            exclusive: false,
            id: choice.id,
            isDefaultChoice: false,
            label: choice.name,
            rollup: '',
            sequence: choice.rank,
        }))
    }

    const mapRecruitmentListToSection = (list) => {
        const recruitmentQuestions = [
            {
                id: "recruitment",
                inputTypeId: PICK_ONE_LIST,
                label: t('user.find_us'),
                required: true,
                section: 'recruit',
                visible: true,
                attributeChoices: mapRecruitmentDetailsToAttribute(list),
            },
            {
                id: "comment",
                inputTypeId: TEXT_INPUT,
                label: t('user.find_us.elaborate'),
                defaultValue: null,
                required: false,
                section: 'recruit',
                visible: true,
                parents: list.filter(x => x.askToElaborate).map(x => x.id),
                attributeValidationRules: [{
                    regex: /^.{0,1000}$/i,
                    errorMessage: t("form.invalid_recruitment_comment_length"),
                }],
            }]
        const config = {
            recruit: recruitmentQuestions,
        }
        setRecruitmentChannelsList(config)
    }

    const onFirstGetAttributesListDone = (attributesList) => {
        setErrorMessage("")
        setIsLoading(false)
        const attributesFirstSection = attributesList.filter(x => x.attributeSequences[0].section == 1)
        setFilterAttributes(attributesFirstSection)
        getCountriesAndMarketsByBrand(props.brandId, props.languageId,
            (countriesResult) => setCountriesAndMarketsByBrand(countriesResult, attributesFirstSection))
    }

    const evaluateCountryLabels = (attributesFirstSection = filterAttributes) => {
        const countryAttribute = attributesFirstSection.find(x => x.id == COUNTRY_OF_RESIDENCE)
        //If country attribute is returned in the first section of the get attributes list
        if (countryAttribute) {
            setCountries((previousState) => {
                return previousState.map(country => {
                    country.label = countryAttribute.attributeChoices.find(choice => choice.id == country.value).label
                    return country
                })
            })
        }
    }

    const onGetJoinSecondBrandSuccess = (joinSecondBrand) => {
        if (props.isShgRegistration) {
            setShowJoinIncrowd(joinSecondBrand)
            if (!joinSecondBrand) {
                //If join incrowd gets hidden, the value of set selected should be set to false
                setJoinIncrowdSelected(false)
            }
        } else {
            setShowJoinOS(joinSecondBrand)
            if (!joinSecondBrand) {
                //If join OS gets hidden, the value of set selected should be set to false
                setJoinOSSelected(false)
            }
        }
    }

    const getOtherBrandAttributesList = (brandId) => {
        const parameters = {
            countryId: countryId,
            marketId: marketId,
            languageId: languageId,
            brandId: brandId,
            userId: props.userId,
            accessToken: props.accessToken,
        }
        setLoadingOtherBrandAttributes(true)
        getAttributesList(parameters, setErrorMessage,
            (attributesList) => keepDistinctAttributes(attributesList))
    }

    const keepDistinctAttributes = (attributeList) => {
        setErrorMessage("")
        attributeList = attributeList.filter(x => x.attributeSequences[0].section != 1)
        Object.keys(attributes).forEach(attributeSection => {
            attributes[attributeSection].forEach((attribute) => {
                attributeList = attributeList.filter(x => x.id != attribute.id)
            })
        })
        setOtherBrandAttributes({ ic: attributeList })
        setLoadingOtherBrandAttributes(false)
    }

    const translateTimeZoneChoices = () => {
      return props.timeZones.map((timeZone) => {
        return {
          ...timeZone,
          label: timeZone.utcTime + t("tz." + timeZone.city),
        }
      })
    }

    useEffect(() => {
        setNonAttributesFields([
            {
                id: "email",
                name: "email",
                inputTypeId: TEXT_INPUT,
                label: t('user.email'),
                defaultValue: props.email,
                required: true,
                section: 3,
                visible: true,
                attributeValidationRules: [{
                    regex: /^\s*[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}\s*$/i,
                    errorMessage: t("form.invalid_email"),
                }],
            },
            {
                id: "timezone",
                name: "timezone",
                inputTypeId: PICK_ONE_LIST,
                label: t('user.time_zone'),
                required: true,
                section: 4,
                visible: true,
                attributeChoices: translateTimeZoneChoices(),
                defaultValue: setTimeZoneDefaultValue(guessTimeZone()),
            },
        ])
    }, [props.email,languageId])

    const onChangeMarket = (market) => {
        setMarketId(market)
        otherBrandEligibleForCountryMarket(countryId, market)
        if (countryId && languageId) {
            setIsLoading(true)
            setAttributes({})
            setPassword({})
            const parameters = {
                countryId: countryId,
                marketId: market,
                languageId: languageId,
                brandId: props.brandId,
                userId: props.userId,
                accessToken: props.accessToken,
            }
            getAttributesList(parameters, setErrorMessage,
                (attributesList) => onGetAttributesListDone(attributesList, true))
        }
    }

    const onChangeCountry = (country, countriesList = countries, newLanguageId = languageId) => {
        setCountryId(country)
        const selectedCountry = countriesList.find(x => x.value == country)
        setCountryIsoCode(selectedCountry.isoCode)
        const newLanguages = selectedCountry.languages.map(language => {
            language.label = props.languages.find(lan => lan.id == language.id).label
            language.value = language.languageId
            return language
        })
        let config = {
            languageId: newLanguageId,
            reevaluateLabels: false,
            newMarketId: marketId,
        }
        let haveTriggeredGetAttributesList = false
        handleLanguages(newLanguages, config)
        const newMarkets = selectedCountry.markets
        setMarkets(mapOptionsToGroups(newMarkets))
        if (newMarkets.length > 1) {
            if (marketId) {
                if (newMarkets.find(x => x.value == marketId) != undefined) {
                    // pre-selected market is still valid for new country
                    haveTriggeredGetAttributesList =
                        onChangeMarketFromCode(country, marketId, config.languageId, config.reevaluateLabels)
                } else {
                    // clear out attribute/password/market data for old selection
                    setMarketId("")
                    config.newMarketId = ""
                    setAttributes({})
                    setPassword({})
                    setShowUniqueSection(false)
                    setShowAttributeList(false)
                }
            }
            setIsMarketDisabled(false)
        } else if (newMarkets.length == 1) {
            // we only have one possible market for this country
            config.newMarketId = newMarkets[0].value
            setMarketId(config.newMarketId)
            setIsMarketDisabled(true)
            haveTriggeredGetAttributesList =
                onChangeMarketFromCode(country, config.newMarketId, config.languageId, config.reevaluateLabels)
        } else {
            // this country does not have any market - shouldn't ever happen
            setMarketId("")
            config.newMarketId = ""
            setIsMarketDisabled(false)
            setAttributes({})
            setPassword({})
            setShowUniqueSection(false)
            setShowAttributeList(false)
        }
        //If the language changed and the api was not triggered previously, reevaluate
        //the attributes to get the new labels for country
        if (config.reevaluateLabels && !haveTriggeredGetAttributesList) {
            onChangeLanguage(config.languageId, false, country, config.newMarketId)
        }
    }

    const onChangeMarketFromCode = (country, market, language, reevaluateLabels) => {
        otherBrandEligibleForCountryMarket(country, market)
        let haveTriggeredGetAttributesList = false
        if (language) {
            setIsLoading(true)
            setAttributes({})
            setPassword({})
            const parameters = {
                countryId: country,
                marketId: market,
                languageId: language,
                brandId: props.brandId,
                userId: props.userId,
                accessToken: props.accessToken,
            }
            haveTriggeredGetAttributesList = true
            getAttributesList(parameters, setErrorMessage,
                (attributesList) =>
                    onGetAttributesListDone(attributesList, true, reevaluateLabels))
            if (reevaluateLabels) {
                //Reevaluate market labels
                getCountriesAndMarketsByBrand(props.brandId, language, (countriesResult) =>
                    setTranslatedMarketLabels(countriesResult, country))
            }
        }
        return haveTriggeredGetAttributesList
    }

    const handleLanguages = (newLanguages, config) => {
        setLanguages(newLanguages)
        if (newLanguages.length > 1) {
            setIsLanguageDisabled(false)
            if (config.languageId && newLanguages.find(x => x.value == config.languageId) == undefined) {
                // clear out attribute/password/language data for old selection
                config.languageId = ""
                setLanguageId("")
                setAttributes({})
                setPassword({})
                setShowUniqueSection(false)
                setShowAttributeList(false)
            }
        } else if (newLanguages.length == 1) {
            // we only have one possible language for this country
            config.reevaluateLabels = newLanguages[0].value != config.languageId
            config.languageId = newLanguages[0].value
            setLanguageId(config.languageId)
            setPageLanguage(newLanguages, config.languageId)
            setIsLanguageDisabled(true)
        } else {
            // this country does not have any language - shouldn't ever happen
            config.languageId = ""
            setLanguageId("")
            setIsLanguageDisabled(false)
            setAttributes({})
            setPassword({})
            setShowUniqueSection(false)
            setShowAttributeList(false)
        }
    }

    const onGetAttributesListDone = (attributesList, showList, reevaluateCountryLabels = false) => {
        setIsLoading(false)
        setHighlightErrors(false)
        setErrorMessage("")
        const stateOfResidence = attributesList.find(x => x.id == STATE_OF_RESIDENCE)
        if (stateOfResidence) {
            setStateOfResidenceChoices(stateOfResidence.attributeChoices)
        }
        //Get updated nonAttributesFields
        let nonAttributes = []
        setNonAttributesFields((previousState) => {
            let fields = [...previousState]
            const emailIndex = fields.findIndex(x => x.id == "email")
            fields[emailIndex].label = <span> {t('user.email')} <i>({t('user.email.personal_recommended')})</i></span>
            fields[emailIndex].attributeValidationRules[0].errorMessage = t('form.invalid_email')
            fields[emailIndex].dataToolTip = t('user.email.personal_recommended_description')
            const timeZoneIndex = fields.findIndex(x => x.id == "timezone")
            previousState[timeZoneIndex].label = t('user.time_zone')
            nonAttributes = fields
            return fields
        })
        const attributesBySection = mapBySection(attributesList, nonAttributes, attributes)
        setUniqueAttributes(buildUniqueAttributes(attributesList))
        setAttributes(attributesBySection)
        if (reevaluateCountryLabels) {
            const attributesFirstSection = attributesList.filter(x => x.attributeSequences[0].section == 1)
            evaluateCountryLabels(attributesFirstSection)
        }
        const showAllSections = attributesList.some(
          (attribute) =>
            attribute.attributeSequences[0].section == UNIQUE_SECTION && attribute.required
        )
        if (showList) {
          if (attributesList.find((x) => x.attributeSequences[0].section == UNIQUE_SECTION)) {
            setShowUniqueSection(true)
            showAllSections ? setShowAttributeList(false) : setShowAttributeList(true)
          } else {
            setShowAttributeList(true)
          }
        }
    }

    const onChangeLanguage = (language, changePageLanguage = true, country = countryId, market = marketId) => {
        setLanguageId(language)
        if (changePageLanguage) {
            setPageLanguage(languages, language)
        }
        setAttributes({})
        setPassword({})
        setIsLoading(country && market)
        const parameters = {
            countryId: country,
            marketId: market,
            languageId: language,
            brandId: props.brandId,
            userId: props.userId,
            accessToken: props.accessToken,
        }
        getAttributesList(parameters, setErrorMessage,
            (attributesList) => onGetAttributesListDone(attributesList, country && market, true))
        //Reevaluate the markets to get the translated market names
        getCountriesAndMarketsByBrand(props.brandId, language, (countriesResult) =>
            setTranslatedMarketLabels(countriesResult, country))
    }

    const setTranslatedMarketLabels = (countriesResult, country = countryId) => {
        setCountries((previousState) => {
            return previousState.map(coun => {
                coun.markets = countriesResult.find(c => c.value == coun.value).markets
                return coun
            })
        })
        const selectedCountry = countriesResult.find(x => x.value == country)
        const newMarkets = selectedCountry.markets
        setMarkets(mapOptionsToGroups(newMarkets))
    }

    const setPageLanguage = (languagesList, language) => {
        const isoCode = languagesList.find(x => x.value == language).isoCode
        i18next.changeLanguage(isoCode)
    }

    const checkAttributeValidity = (attribute) => {
        return !(attribute.visible && !attribute.valid)
    }

    const checkFormValidity = () => {
        let valid = true
        Object.keys(attributes).forEach(sectionId => {
            attributes[sectionId].forEach(attr => {
                valid = checkAttributeValidity(attr) ? valid : false
            })
        })
        if (Object.keys(otherBrandAttributes).length > 0) {
            Object.keys(otherBrandAttributes).forEach(key => {
                otherBrandAttributes[key].forEach(attr => {
                    valid = checkAttributeValidity(attr) ? valid : false
                })
            })
        }
        // Check if recruitment data filled and display error on it
        if (Object.keys(recruitmentChannelsList).length > 0) {
            Object.keys(recruitmentChannelsList).forEach(key => {
                recruitmentChannelsList[key].forEach(attr => {
                    valid = checkAttributeValidity(attr) ? valid : false
                })
            })
        }
        if (countryIsoCode === "us" && mobileNumber.value.length <= 2) {
            valid = valid && Boolean(password.valid) && Boolean(sendEmailAndSms.valid) && Boolean(termsAndConditions.valid)
        } else {
            valid = valid && password.valid && mobileNumber.valid && sendEmailAndSms.valid && termsAndConditions.valid
        }
        return valid
    }

    const register = () => {
        setErrorMessage("")
        if (checkFormValidity()) {
            let result = gatherAttributeInfo()
            setIsButtonLoading(true)
            const parameters = {
                countryId: countryId,
                marketId: marketId,
                brandId: props.brandId,
                userId: props.userId,
                email:email,
                accessToken: props.accessToken,
                joinIncrowd: joinIncrowdSelected,
                joinOS: joinOSSelected,
                translation: t,
                otherBrandId: joinedOtherBrandId,
                getAttributeLabelById: getAttributeLabelById,
            }
            const payload = result.filter(attr => !(attr.inputTypeId == 1 && attr.attributeTextValue == "" && !attr.required))
            postAttributesList(payload, parameters, setErrorMessage, setIsButtonLoading, () => onAttributesApiDone(result))
        } else {
            setHighlightErrors(true)
            setErrorMessage(t("form.invalid_form"))
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            })
        }
    }
    const getAttributeLabelById = (id) => {
        for(const value of Object.values(attributes)){
            for(const attribute of value){
                if(attribute.id == id){
                    return attribute.label
                }
            }
        }
    }

    const buildAttributeList = (attributeArray, destinationArray) => {
        attributeArray.forEach(attr => {
            if (attr.visible && !isNaN(attr.id)) {
                destinationArray.push(buildAttribute(attr))
            }
        })
    }

    const gatherAttributeInfo = () => {
        let result = []
        Object.keys(attributes).forEach(sectionId => {
            buildAttributeList(attributes[sectionId], result)
        })
        if (Object.keys(otherBrandAttributes).length > 0) {
            Object.keys(otherBrandAttributes).forEach(key => {
                buildAttributeList(otherBrandAttributes[key], result)
            })
        }
        if (filterAttributes.find(x => x.id == COUNTRY_OF_RESIDENCE)) {
            result.push({ attributeId: COUNTRY_OF_RESIDENCE, attributeChoiceIds: [countryId] })
        }
        if (filterAttributes.find(x => x.id == LANGUAGE)) {
            const language = props.languages.find(x => x.value == languageId).id
            result.push({ attributeId: LANGUAGE, attributeChoiceIds: [language] })
        }
        return result
    }

    const buildAttribute = (attr) => {
        let attrResult = {
            attributeId: attr.id,
            required: attr.required,
            inputTypeId: attr.inputTypeId,
        }
        if (isText(attr.inputTypeId)) {
            attrResult.attributeTextValue = attr.value.trim()
        }
        if (isInteger(attr.inputTypeId)) {
            attrResult.attributeIntegerValue = attr.value ? +attr.value : null
        }
        if (isPickOne(attr.inputTypeId) || isPickMany(attr.inputTypeId)) {
            attrResult.attributeChoiceIds = attr.value
        }
        return attrResult
    }

    const onAttributesApiDone = (result) => {
        const payload = prepareRegisterPayload(result)
        generateNewCaptchaToken((recaptchaToken) => {
            const parameters = {
                userId: props.userId,
                accessToken: props.accessToken,
                captchaToken: recaptchaToken,
                languageId: languageId,
                translation: t,
            }
            props.setEmail(payload.email)
            secondRegister(payload, parameters, setErrorMessage, setIsButtonLoading, onRegisterApiDone)
        })

    }

    const prepareRegisterPayload = (result) => {
        const emailSection = nonAttributeFields.find(x => x.id == "email").section
        const timeZoneSection = nonAttributeFields.find(x => x.id == "timezone").section
        const stateOfResidenceAttribute = result.find(attr => attr.attributeId == STATE_OF_RESIDENCE)
        const state = stateOfResidenceAttribute ? stateOfResidenceChoices.find(
            x => x.id == stateOfResidenceAttribute.attributeChoiceIds[0]) : null
        const zipCode = result.find(attr => attr.attributeId == ZIP_CODE)
        let config = {
            id: props.userId,
            joinIncrowd: joinIncrowdSelected,
            joinOS: joinOSSelected,
            marketId: marketId,
            countryId: countryId,
            languageId: props.languages.find(x => x.value == languageId).id,
            email: attributes[emailSection].find(x => x.id == "email").value.trim(),
            sms: mobileNumber.value.length > 2 ? mobileNumber.value : "",
            password: password.value,
            firstName: result.find(attr => attr.attributeId == FIRST_NAME).attributeTextValue,
            lastName: result.find(attr => attr.attributeId == LAST_NAME).attributeTextValue,
            address: {
                address1: result.find(attr => attr.attributeId == ADDRESS_1).attributeTextValue,
                address2: result.find(attr => attr.attributeId == ADDRESS_2).attributeTextValue,
                city: result.find(attr => attr.attributeId == CITY).attributeTextValue,
                state: state ? state.label : "",
                zipCode: zipCode ? zipCode.attributeTextValue : "",
            },
            timeZone: attributes[timeZoneSection].find(x => x.id == "timezone").value[0],
            acceptedTerms: termsAndConditions.acceptedTerms ? termsAndConditions.acceptedTerms : false,
            contactByEmail: sendEmailAndSms.sendEmails,
            contactBySms: sendEmailAndSms.sendSms,
            languages: [],
            subscriptionIds: [],
            responderTypeId: props.responderTypeId,
        }
        if (Object.keys(recruitmentChannelsList).length > 0) {
            const comment = recruitmentChannelsList['recruit'].find(x => x.id == "comment").value
            config.recruitmentId = recruitmentChannelsList['recruit'].find(x => x.id == "recruitment").value[0]
            config.recruitmentComment = comment != undefined ? comment : null
        }
        return config
    }

    const onRegisterApiDone = (result) => {
        Storage.setItem('cognito-token-login', result.cognitoToken)
        setIsButtonLoading(false)
        //redirect
        props.showValidation()
    }

    const onEmailChange = (email) => {
        setEmail(email)
        //If it is eligible for Country and Market, check if eligible for new email
        //Otherwise, I don't care about the email change if not eligible for the country and market
        showSecondBrand(email, props.isShgRegistration ? OS_RESPONDER_TYPE_ID
            : INCROWD_RESPONDER_TYPE_ID, props.userId, countryId, marketId,
            props.isShgRegistration ? INCROWD_BRAND : OS_HCP_BRAND, onGetJoinSecondBrandSuccess)
    }

    const otherBrandEligibleForCountryMarket = (countryIdValue, marketValue) => {
        //If it is eligible for Email, check if eligible for newly selected country and market
        //Otherwise, I don't care about the country/market change if not eligible for the email
        showSecondBrand(email, props.isShgRegistration ? OS_RESPONDER_TYPE_ID
            : INCROWD_RESPONDER_TYPE_ID, props.userId, countryIdValue,
            marketValue, props.isShgRegistration ? INCROWD_BRAND : OS_HCP_BRAND, onGetJoinSecondBrandSuccess)
    }

    const selectJoinIncrowd = (isSelected) => {
        setJoinIncrowdSelected(isSelected)
    }

    const selectJoinOS = (isSelected) => {
        setJoinOSSelected(isSelected)
    }


    const getMarketValue = () => {
        if (marketId != '') {
            for (const market of markets) {
                for (const option of market.options) {
                    if (option.value == marketId) {
                        return option
                    }
                }
            }
        }
        return null
    }

    const checkUniqueValue = (attributeId, value, callbackFunction) => {
        const payload = {
          attributeId: attributeId,
          attributeValue: value,
        }
        checkUniqueAttribute(props.userId, payload,setErrorMessage, (response) => {
          callbackFunction(response)
        })
    }
    return (
        <div id="registration-hero" className="welcome-page">
            <div className="white-block-forms" id="registration-slider">
                <div className="carousel slide slide-view" data-ride="carousel" id="carousel-32">
                    <div className="carousel-inner"><div className="item slide-content slide-1 active">
                        <div className="step details">
                            <div className="container center-block">
                                <h1>{t('welcome')}</h1>
                                <p className="welcome-message">{t('details.need_info_description')}</p>
                                {errorMessage && errorMessage.length > 0 && (
                                    <p className='welcome-error-message'><i className='im-warning'></i>{errorMessage}</p>
                                )}
                                <div className="major-sections">
                                    {filterAttributes.length > 0 &&
                                        <div className="section profession">
                                            <div id="form-profession-section">
                                                {filterAttributes.find(x => x.id == COUNTRY_OF_RESIDENCE) &&
                                                    <div>
                                                        <p className="filter-title">{t('user.country_of_res?')}</p>
                                                        <Select
                                                            placeholder=
                                                            {filterAttributes.find(x => x.id == COUNTRY_OF_RESIDENCE)
                                                                .placeholderText}
                                                            id={COUNTRY_OF_RESIDENCE}
                                                            value={countryId == '' ? null : countries.find(country => country.value == countryId)}
                                                            options={countries}
                                                            isDisabled={isCountryDisabled}
                                                            onChange={(event) => {
                                                                onChangeCountry(event.value)
                                                            }}
                                                            styles={customStyles()}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                        />
                                                    </div>
                                                }
                                                {filterAttributes.find(x => x.id == LANGUAGE) &&
                                                    <div>
                                                        <p className="filter-title">{t('user.primary_lang?')}</p>
                                                        <Select
                                                            id={LANGUAGE}
                                                            placeholder={filterAttributes.find(x => x.id == LANGUAGE)
                                                                .placeholderText}
                                                            value={languageId == '' ? null : languages.find(language => language.value == languageId)}
                                                            options={languages}
                                                            onChange={(event) => {
                                                                onChangeLanguage(event.value)
                                                            }}
                                                            styles={customStyles()}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            isDisabled={isLanguageDisabled}
                                                        />
                                                    </div>
                                                }
                                                <div>
                                                    <p className="filter-title">{t('user.profession?')}</p>
                                                    <Select
                                                        id="Select Profession"
                                                        placeholder={t("form.select_profession")}
                                                        value={getMarketValue()}
                                                        options={markets}
                                                        onChange={(event) => {
                                                            onChangeMarket(event.value)
                                                        }}
                                                        styles={customStyles()}
                                                        components={{
                                                            IndicatorSeparator: () => null,
                                                        }}
                                                        isDisabled={isMarketDisabled}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {isLoading && <img className="loader" src={spinnerSrc} />}
                                    {showUniqueSection && (
                                        Object.keys(attributes).map((sectionId) => (
                                            sectionId === UNIQUE_SECTION &&
                                            <SectionComponent key={sectionId}
                                                id={sectionId}
                                                name={t(sectionNames[sectionId])}
                                                highlightErrors={highlightErrors}
                                                isShgRegistration={props.isShgRegistration}
                                                countryIsoCode={countryIsoCode}
                                                onEmailChange={onEmailChange}
                                                setAttributes={setAttributes}
                                                setPassword={setPassword}
                                                setSendEmailAndSms={setSendEmailAndSms}
                                                setMobileNumber={setMobileNumber}
                                                checkUniqueValue={checkUniqueValue}
                                                setUniqueAttributes={setUniqueAttributes}
                                                checkUniqueAttributesValidity={checkUniqueAttributesValidity}
                                                />
                                        ))
                                    )}
                                    {showAttributeList && (
                                        Object.keys(attributes).map((sectionId) => (
                                            sectionId !=UNIQUE_SECTION &&
                                            <SectionComponent key={sectionId}
                                                id={sectionId}
                                                name={t(sectionNames[sectionId])}
                                                highlightErrors={highlightErrors}
                                                isShgRegistration={props.isShgRegistration}
                                                countryIsoCode={countryIsoCode}
                                                onEmailChange={onEmailChange}
                                                setAttributes={setAttributes}
                                                setPassword={setPassword}
                                                setSendEmailAndSms={setSendEmailAndSms}
                                                setMobileNumber={setMobileNumber}
                                                checkUniqueValue={checkUniqueValue}
                                                />
                                        ))
                                    )}
                                    {!isLoading && showAttributeList && displayRecruitment &&
                                        <RecruitmentComponent
                                            recruitmentChannelsList={recruitmentChannelsList}
                                            setRecruitmentChannelsList={setRecruitmentChannelsList}
                                            highlightErrors={highlightErrors}
                                        />
                                    }
                                    {!isLoading && showAttributeList && props.isShgRegistration && showJoinIncrowd &&
                                        <JoinIncrowdComponent
                                            attributes={otherBrandAttributes}
                                            setAttributes={setOtherBrandAttributes}
                                            highlightErrors={highlightErrors}
                                            getOtherBrandAttributesList={getOtherBrandAttributesList}
                                            spinnerSrc={spinnerSrc}
                                            setJoinedOtherBrandId={setJoinedOtherBrandId}
                                            selectJoinIncrowd={selectJoinIncrowd}
                                            userId={props.userId}
                                            languageId={languageId}
                                        />
                                    }
                                    {!isLoading && showAttributeList && !props.isShgRegistration && showJoinOS &&
                                        <JoinOpinionSiteComponent
                                            attributes={otherBrandAttributes}
                                            setAttributes={setOtherBrandAttributes}
                                            highlightErrors={highlightErrors}
                                            getOtherBrandAttributesList={getOtherBrandAttributesList}
                                            spinnerSrc={spinnerSrc}
                                            setJoinedOtherBrandId={setJoinedOtherBrandId}
                                            selectJoinOS={selectJoinOS}
                                            userId={props.userId}
                                            languageId={languageId}
                                        />
                                    }
                                     {!isLoading && showAttributeList && (
                                        <div>
                                            <TermsAndConditionsComponent userId={props.userId}
                                                highlightErrors={highlightErrors}
                                                setTermsAndConditions={setTermsAndConditions}
                                                languageId={languageId} />
                                        </div>
                                    )}
                                    {!isLoading && showAttributeList && (
                                        <div>
                                            <div className="separator-2"></div>
                                            <div className="section register">
                                                <Button
                                                    className="btn btn-register finish-creating-account-btn"
                                                    type="button"
                                                    name="Finish Creating Account Button"
                                                    isLoading={isButtonLoading}
                                                    onClick={register}
                                                    disabled={joinedOtherBrandId > 0 && loadingOtherBrandAttributes}>
                                                    <span>{t('form.finish_creating_account')}</span>
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WelcomeComponent
